<template>
	<div class="absolute flex justify-center items-center">
		<div
			ref="timer"
			style="border-radius: 50%"
			:style="{
				width: width + 'px',
				height: width + 'px',
				// backgroundColor: 'red',
				backgroundImage: 'conic-gradient(' + progressColor + ' ' + circle.angle + 'deg, ' + backgroundColor + ' 0)',
				border: 'solid 1px white',
			}"
		></div>
		<p class="absolute text-white text-[43px] top-[-5px]" ref="textEl">{{ minute }}</p>
		<p class="absolute text-white text-[20px] top-[42px]">min</p>
	</div>
</template>
<script>
/* eslint-disable */
import { gsap, Linear } from "gsap";
export default {
	name: "timer-1",
	props: {
		width: { default: 75 },
		progressColor: { default: "#4d4d4d" },
		backgroundColor: { default: "#000000" },
		countdown: { default: 10 },
	},
	data() {
		return {
			circle: { angle: 0 },
			minute: 0,
		};
	},
	methods: {
		start() {},
		set(val) {
			gsap.set(this.circle, {
				angle: val * 360,
			});
			this.minute = Math.floor(val * 15);
		},
		reset() {
			// this.circle.angle = 0;
			gsap.set(this.circle, { angle: 0, overwrite: true });
			this.minute = 0;
		},
	},
	//   mounted(){
	//     this.start();
	//   }
};
</script>
